import { render, staticRenderFns } from "./water-meter.vue?vue&type=template&id=6c2c4378&scoped=true"
import script from "./water-meter.vue?vue&type=script&lang=js"
export * from "./water-meter.vue?vue&type=script&lang=js"
import style0 from "./water-meter.vue?vue&type=style&index=0&id=6c2c4378&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c2c4378",
  null
  
)

export default component.exports